import * as React from 'react';
import { getOrderedTeamNames, MatchPartsForTeamNames } from '../matchUtils';

interface Props {
  match: MatchPartsForTeamNames;
}

export const MatchTeams: React.FC<Props> = ({ match }) => {
  const [homeTeam, awayTeam] = getOrderedTeamNames(match);

  return (
    <>
      <span className={!match.atHome ? 'font-semibold' : 'text-grey-600'}>
        {homeTeam}
      </span>{' '}
      v{' '}
      <span className={match.atHome ? 'font-semibold' : 'text-grey-600'}>
        {awayTeam}
      </span>
    </>
  );
};
